import { AccessDenied } from '../components/shared/AccessDenied/AccessDenied.js';
import OnboardSuccess from '../components/shared/common/OnboardSuccess';
import OnboardRefresh from '../components/shared/common/OnboardRefresh';
import DashboardPerformanceAnalysisContainer from '../components/Admin/DashboardPerformanceAnalysis/DashboardPerformanceAnalysisContainer';
import { withLazyLoad } from '../components/shared/LazyLoad/WithLazyLoad';
import DashboardList from '../components/Analytics/Dashboard/DashboardList';
import DashboardContainer from '../components/Analytics/DashboardContainer';
import { WebAppAccess } from '../components/shared/AccessDenied/WebAppAccess';
import { MODULES } from '../constants.js';

import permissions from './permissions';

export const routes = [
  {
    path: '/dashboard',
    title: 'Home',
    component: DashboardContainer,
    permissions: permissions.home.menu,
    identifier: 'home',
  },
  {
    path: '/dashboard-widget',
    title: 'Home',
    component: DashboardContainer,
    permissions: permissions.home.menu,
    identifier: 'widget_dashboard',
  },
  {
    path: MODULES.ENTITY.BASE_ROUTE,
    title: MODULES.ENTITY.TITLE,
    component: withLazyLoad(() => import('../components/Entity')),
    identifier: MODULES.ENTITY.IDENTIFIER,

    exact: true,
  },
  {
    path: MODULES.ENTITY.EDIT_FORM_ROUTE_WITH_PARAM,
    title: MODULES.ENTITY.EDIT_FORM_TITLE,
    component: withLazyLoad(() => import('../components/Entity')),
    identifier: MODULES.ENTITY.IDENTIFIER,

    exact: true,
  },
  {
    path: MODULES.ENTITY.VIEW_FORM_ROUTE_WITH_PARAM,
    title: MODULES.ENTITY.VIEW_FORM_TITLE,
    component: withLazyLoad(() => import('../components/Entity')),

    exact: true,
  },
  {
    path: MODULES.ENTITY.ADD_FORM_ROUTE_WITH_PARAM,
    title: MODULES.ENTITY.ADD_FORM_TITLE,
    component: withLazyLoad(() => import('../components/Entity')),

    exact: true,
  },
  {
    path: MODULES.ENTITY.ENTITY_ROUTE_WITH_PARAM,
    title: MODULES.ENTITY.TITLE,
    component: withLazyLoad(() => import('../components/Entity')),
    identifier: MODULES.ENTITY.IDENTIFIER,

    exact: true,
  },

  {
    path: '/routing',
    title: 'Routing',
    component: withLazyLoad(
      () => import('../components/ProjectManagement/Scheduling/Routing/Routing')
    ),
    identifier: 'routing',
  },
  {
    path: '/getstarted',
    title: 'Get Started',
    component: withLazyLoad(
      () => import('../components/GetStarted/GetStarted')
    ),
    identifier: 'get_started',
  },
  {
    path: MODULES.SUPPORT.BASE_ROUTE,
    title: MODULES.SUPPORT.TITLE,
    component: withLazyLoad(() => import('../components/Support')),
    identifier: MODULES.SUPPORT.IDENTIFIER,
    permissions: permissions.support.menu,
    exact: true,
  },
  {
    path: MODULES.SUPPORT.TICKET_ROUTE_WITH_PARAM,
    title: MODULES.SUPPORT.TITLE,
    component: withLazyLoad(() => import('../components/Support')),
    identifier: MODULES.SUPPORT.IDENTIFIER,
    permissions: permissions.support.menu,
    exact: true,
  },
  {
    path: '/project/map',
    title: 'Map',
    component: withLazyLoad(() => import('../components/Map/components/Map')),
    permissions: permissions.map.view,
    identifier: 'map',
  },
  {
    path: '/project/clients',
    title: 'Clients',
    component: withLazyLoad(
      () => import('../components/ProjectManagement/Clients/Clients')
    ),
    permissions: permissions.clients.menu,
    identifier: 'clients',
  },
  {
    path: '/project/items',
    title: 'Items',
    component: withLazyLoad(
      () => import('../components/ProjectManagement/Items/ItemsNew.js')
    ),
    permissions: permissions.items.menu,
    identifier: 'items',
  },
  {
    path: `/project/items/group-items/add`,
    title: 'Group Items',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/Items/GroupItems/add-edit-group-item'
        )
    ),
  },

  {
    path: '/project/:action/:projectId/viewProjectDocument/:documentType/:documentId',
    title: 'View Document',
    component: withLazyLoad(
      () => import('../components/ProjectManagement/Docs/ViewDocumentNew')
    ),
    identifier: 'view_document',
  },

  {
    path: '/admin/stores',
    title: 'Stores',
    component: withLazyLoad(
      () => import('../components/Admin/Stores/StoresContainer')
    ),
    permissions: permissions.stores.menu,
    identifier: 'stores',
  },
  {
    path: '/admin/warehouse',
    title: 'Warehouse',
    component: withLazyLoad(() => import('../components/Locations/Warehouse')),
    identifier: 'warehouse',
  },
  {
    path: '/project/personalized-emails-template',
    title: 'personalizedEmails',
    component: withLazyLoad(
      () => import('../components/EmailTemplates/EmailTemplatesContainer')
    ),
    permissions: permissions.email.view,
    identifier: 'personalizedEmails',
  },
  {
    path: '/stores/view/:storeId?',
    title: 'Store Details',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Stores/components/AddViewEditStoreDetails')
    ),
    permissions: permissions.stores.menu,
    identifier: 'view_store_details',
  },
  {
    path: '/stores/add',
    title: 'Store Details',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Stores/components/AddViewEditStoreDetails')
    ),
    permissions: permissions.stores.storesAdd,
    identifier: 'add_store_details',
  },
  {
    path: '/stores/edit/:storeId?',
    title: 'Store Details',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Stores/components/AddViewEditStoreDetails')
    ),
    permissions: permissions.stores.storesEdit,
    identifier: 'edit_store_details',
  },
  {
    path: '/admin/documentcenter',
    title: 'Document Center',
    component: withLazyLoad(
      () => import('../components/Admin/DocumentCenter/Templates')
    ),
    permissions: permissions.documentCenter.menu,
    identifier: 'document_center',
  },
  {
    path: '/admin/documentcenter/view/:templateId',
    title: 'Document Center',
    component: withLazyLoad(
      () => import('../components/Admin/DocumentCenter/ViewEditPdfTemplate')
    ),
    permissions: permissions.documentCenter.menu,
    identifier: 'view_document_center',
  },
  {
    path: '/admin/documentcenter/edit/:templateId',
    title: 'Document Center',
    component: withLazyLoad(
      () => import('../components/Admin/DocumentCenter/ViewEditPdfTemplate')
    ),
    permissions: permissions.documentCenter.editDocTemplate,
    identifier: 'edit_document_center',
  },
  {
    path: '/admin/laborprofiles',
    title: 'Labor Profiles',
    component: withLazyLoad(
      () => import('../components/Admin/LaborProfiles/LaborProfilesContainer')
    ),

    permissions: permissions.laborProfiles.menu,
    identifier: 'labor_profile',
  },
  {
    path: '/laborprofiles/view/:installerId',
    title: 'Labor Profile Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/LaborProfiles/components/AddViewEditLaborProfileDetailsContainer'
        )
    ),
    permissions: permissions.laborProfiles.menu,
    identifier: 'view_labor_profile_details',
  },
  {
    path: '/laborprofiles/edit/:installerId',
    title: 'Labor Profile Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/LaborProfiles/components/AddViewEditLaborProfileDetailsContainer'
        )
    ),
    permissions: permissions.laborProfiles.laborProfileEdit,
    identifier: 'edit_labor_profile_details',
  },
  {
    path: '/laborprofiles/add',
    title: 'Labor Profile Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/LaborProfiles/components/AddViewEditLaborProfileDetailsContainer'
        )
    ),
    permissions: permissions.laborProfiles.laborProfileAdd,
    identifier: 'add_labor_profile_details',
  },
  {
    path: '/admin/usermanagement',
    title: 'User Management',
    component: withLazyLoad(
      () => import('../components/Admin/UserManagement/UserManagement')
    ),
    permissions: permissions.userManagement.menu,
    identifier: 'user_management',
  },
  {
    path: '/admin/usermanagement/user-form/add',
    title: 'User Form',
    component: withLazyLoad(
      () => import('../components/Admin/user-form/user-form-layout')
    ),
    permissions: permissions.userManagement.userManagementAdd,
    identifier: 'add_user_form',
  },
  {
    path: '/admin/usermanagement/user-form/view/:user',
    title: 'User Form',
    component: withLazyLoad(
      () => import('../components/Admin/user-form/user-form-layout')
    ),
    permissions: permissions.userManagement.userManagementEdit,
    identifier: 'view_user_form',
  },
  {
    path: '/admin/usermanagement/user-form/edit/:user',
    title: 'User Form',
    component: withLazyLoad(
      () => import('../components/Admin/user-form/user-form-layout')
    ),
    permissions: permissions.userManagement.userManagementEdit,
    identifier: 'edit_user_form',
  },
  {
    path: '/admin/municipality-management',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MunicipalityRegistration/MunicipalityRegistration'
        )
    ),
    title: 'Municipality Registration',
    permissions: permissions.municipalityRegistration.menu,
    identifier: 'municipality-management-list',
  },
  {
    path: '/admin/municipality-management/add',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MunicipalityRegistration/MunicipalityRegistration'
        )
    ),
    title: 'Add Municipality',
    permissions: permissions.municipalityRegistration.add,
    identifier: 'municipality-management-add',
  },
  {
    path: '/admin/municipality-management/edit/:id',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MunicipalityRegistration/MunicipalityRegistration'
        )
    ),
    title: 'Edit Municipality',
    permissions: permissions.municipalityRegistration.edit,
    identifier: 'municipality-management-edit',
  },
  {
    path: '/admin/municipality-management/view/:id',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MunicipalityRegistration/MunicipalityRegistration'
        )
    ),
    title: 'View Municipality',
    permissions: permissions.municipalityRegistration.menu,
    identifier: 'municipality-management-view',
  },
  {
    path: '/admin/company-management',
    title: 'Company Management',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/CompanyManagement/CompanyManagement'
        )
    ),
    permissions: permissions.companyManagement.view,
    identifier: 'company_management',
  },
  {
    path: '/admin/company-management/view/:id',
    title: 'Company Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/CompanyManagement/CompanyDetails'
        )
    ),
    permissions: permissions.companyManagement.view,
    identifier: 'company_management_view',
  },
  {
    path: '/project/vendormanagement',
    title: 'Vendor Management',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/VendorManagement/VendorManagement'
        )
    ),
    permissions: permissions.vendorManagement.view,
    identifier: 'vendor_management',
  },
  {
    path: '/project/general-orders',
    title: 'General Orders',
    component: withLazyLoad(
      () => import('../components/Admin/GeneralOrders/GeneralOrdersContainer')
    ),
    permissions: permissions.generalPurchaseOrder.view,
    identifier: 'general_orders',
  },

  {
    path: '/admin/rolemanagement',
    title: 'Role Management',
    component: withLazyLoad(
      () => import('../components/Admin/RoleManagement/RoleManagementContainer')
    ),
    permissions: permissions.userManagement.userManagementManageRolesView,
    identifier: 'role_management',
  },
  {
    path: '/admin/rolemanagement/:role_id/permissions',
    title: 'Role Permissions',
    component: withLazyLoad(
      () => import('../components/Admin/RoleManagement/PermissionContainer')
    ),
    identifier: 'role_permission',
  },

  {
    path: '/admin/rolemanagement/:role_id/project-items-configure',
    title: 'Project Items Configuration',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/RoleManagement/ProjectItemsConfiguration/ProjectItemsConfiguration'
        )
    ),
    identifier: 'role_permission',
  },

  {
    path: '/scheduler',
    title: 'Scheduler',
    component: withLazyLoad(
      () => import('../components/SchedulerBeta/SchedulerContainerWrapper')
    ),
    permissions: permissions.viewEditProject.actionScheduler,
    identifier: 'schedular',
  },

  {
    path: '/calendar',
    title: 'Calendar',
    component: withLazyLoad(
      () => import('../components/SchedulerBeta/SchedulerContainerWrapper')
    ),
    permissions: permissions.viewEditProject.viewCalendar,
    identifier: 'calendar',
  },

  {
    path: '/scheduler/:projectNumber/:projectId',
    title: 'Scheduler',
    component: withLazyLoad(
      () => import('../components/SchedulerBeta/SchedulerContainerWrapper')
    ),
    permissions: permissions.viewEditProject.actionScheduler,
    identifier: 'scheduler_by_project_number',
  },
  {
    path: '/admin/dashboards',
    title: 'Dashboard',
    component: DashboardList,
    permissions: permissions.dashboardManagement.menu,
    identifier: 'dashboard_list',
  },
  {
    path: '/admin/dashboard/view/:id',
    title: 'View Dashboard',
    component: withLazyLoad(
      () => import('../components/Analytics/DashboardContainer')
    ),
    permissions: permissions.dashboardManagement.menu,
    identifier: 'view_dashboard',
  },
  {
    path: '/admin/dashboard/edit/:id',
    title: 'Edit Dashboard',
    component: withLazyLoad(
      () => import('../components/Analytics/DashboardContainer')
    ),
    permissions: permissions.dashboardManagement.editDashboard,
    identifier: 'edit_dashboard',
  },
  {
    path: '/admin/dashboard/create/:id',
    title: 'Create Dashboard',
    component: withLazyLoad(
      () => import('../components/Analytics/DashboardContainer')
    ),
    permissions: permissions.dashboardManagement.createDashboard,
    identifier: 'create_dashboard',
  },
  {
    path: '/admin/ruleenginelogs',
    title: 'Rule Engine Logs',
    component: withLazyLoad(
      () => import('../components/Admin/RuleEngineLogs/RuleEngineLogsContainer')
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'rule_engine_logs',
  },
  {
    path: '/admin/ruleenginelogs/:id',
    title: 'Engine Result',
    component: withLazyLoad(
      () => import('../components/Admin/RuleEngineLogs/RuleEngineLogsContainer')
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'rule_engine_logs',
  },
  {
    path: '/admin/tenant-billing',
    title: 'Tenant Billing',
    component: withLazyLoad(
      () => import('../components/Admin/TennantBilling/TenantBilliingContainer')
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'tenant_billing',
  },
  {
    path: '/admin/bulletin',
    title: 'Bulletin',
    component: withLazyLoad(
      () => import('../components/Admin/Bulletin/BulletinContainer')
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'bulletin',
  },
  {
    path: '/call-history',
    title: 'Call History',
    component: withLazyLoad(
      () => import('../components/CallHistory/CallHistoryContainer')
    ),
    permissions: permissions.home.menu,
    identifier: 'call_history',
  },
  {
    path: '/personnel/availabilityupdates',
    title: 'Availability Updates',
    component: withLazyLoad(
      () =>
        import(
          '../components/Personnel/AvailabilityUpdates/components/AvailabilityUpdates'
        )
    ),
    permissions: permissions.availabilityUpdates.menu,
    identifier: 'availability_updates',
  },

  {
    path: '/widget/details/:widgetId',
    title: 'Widget Details',
    component: withLazyLoad(
      () => import('../components/Analytics/Dashboard/ReportDetails')
    ),
    identifier: 'widgets_details',
  },
  {
    path: '/admin/widgets',
    title: 'Widgets',
    component: withLazyLoad(
      () =>
        import(
          '../components/Analytics/Dashboard/Widgets/components/WidgetTemplateList'
        )
    ),
    permissions: permissions.widgetManagement.menu,
    identifier: 'widgets',
  },
  {
    path: '/admin/widget/create',
    title: 'Create Widget',
    component: withLazyLoad(
      () => import('../components/Analytics/DashboardContainer')
    ),
    permissions: permissions.widgetManagement.createWidget,
    identifier: 'create_widgets',
  },
  {
    path: '/admin/widget/view/:widgetId',
    title: 'View Widget',
    component: withLazyLoad(
      () => import('../components/Analytics/DashboardContainer')
    ),
    permissions: permissions.widgetManagement.menu,
    identifier: 'view_widgets',
  },
  {
    path: '/admin/widget/edit/:widgetId',
    title: 'Edit Widget',
    component: withLazyLoad(
      () => import('../components/Analytics/DashboardContainer')
    ),
    permissions: permissions.widgetManagement.editWidget,
    identifier: 'edit_widgets',
  },
  {
    path: '/payment-request/:payment_request_id?',
    title: 'Payment Request',
    component: withLazyLoad(
      () => import('../components/Billing/BillingContainer')
    ),
    permissions: permissions.viewEditProject.paymentRequestMenu,
    identifier: 'payment_request',
  },
  {
    path: '/lrrp-configuration',
    title: 'LRRP COnfiguration',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/LrrpConfiguration')
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'lrrp_configuration',
  },
  {
    path: '/ro-config',
    title: 'Route Configuration',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/RoConfiguration')
    ),
    identifier: 'route_config',
  },
  {
    path: '/crm/:mode/customer',
    title: 'Clients',
    component: withLazyLoad(
      () => import('../components/CRM/Clients/CustomerContainer2')
    ),
    permissions: permissions.clients.addClient,
    identifier: 'clients_crm_mode',
  },
  {
    path: '/crm/:mode/customer/:customerId',
    title: 'Clients',
    component: withLazyLoad(
      () => import('../components/CRM/Clients/CustomerContainer2')
    ),
    permissions: permissions.clients.menu,
    identifier: 'clients_crm_mode_by_id',
  },
  {
    path: '/warranty-config',
    title: 'Warranty Configuration',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/WarrantyConfiguration.js')
    ),
    identifier: 'warranty_config',
  },
  {
    path: '/crm/:customerId/opportunity/:mode/:actionId?',
    title: 'Opportunity',
    component: withLazyLoad(
      () => import('../components/CRM/Opportunities/OpportunityContainer')
    ),
    permissions: permissions.clients.addClient,
    identifier: 'opportunity',
  },
  {
    path: '/crm-config',
    title: 'CRM Configuration',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/CrmConfiguration.jsx')
    ),
    identifier: 'crm_config',
  },
  {
    path: '/admin/configuration',
    title: 'Company Configuration',
    component: withLazyLoad(
      () => import('../components/Admin/NewConfiguration/CompanyConfig.js')
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'new_config',
  },
  {
    path: '/admin/configuration/zipcode-mapping',
    title: 'Zipcode Mapping',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Configuration/ZipcodeDocumentTypeMapping/ZipcodeDocumentTypeMappingContainer'
        )
    ),
    permissions: permissions.ruleEngineLog.menu,
    identifier: 'zipcode_document_type_mapping',
  },
  {
    path: '/admin/company-config/edit/:id',
    title: 'Edit Company Configuration',
    component: withLazyLoad(
      () => import('../components/Admin/NewConfiguration/EditCompanyConfig.js')
    ),
    identifier: 'edit_company_config',
  },
  {
    path: '/admin/company/business-hour-config/edit/:id',
    title: 'Business Hour Configurations',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/BusinessHourConfig/BusinessHourConfig.js'
        )
    ),
    identifier: 'edit_company_business_hour_config',
  },
  {
    path: '/admin/company/cx-scheduling-config/edit/:id',
    title: 'Customer Scheduling Configurations',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/CxSchedulingConfig/CxSchedulingConfig.js'
        )
    ),
    identifier: 'edit_company_cx_scheduling_config',
  },
  {
    path: '/admin/company/service-time-config/edit/:id',
    title: 'Service Time Configurations',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/ServiceTimeConfig/ServiceTimeConfig.js'
        )
    ),
    identifier: 'edit_company_service_time_config',
  },
  {
    path: '/project/Quote-template',
    title: 'Quote Template',
    component: withLazyLoad(
      () =>
        import('../components/Admin/QuoteTemplate/Components/TemplateListing')
    ),
    permissions: permissions.quote?.view,
    identifier: 'template_listing',
  },
  {
    path: '/admin/:viewaction/:quoteId/quote-template/:id',
    title: 'Quote Template',
    component: withLazyLoad(
      () =>
        import('../components/Admin/QuoteTemplate/Components/QuotesTemplate')
    ),
    permissions: permissions.quote?.view,
    identifier: 'quote_template',
  },
  {
    path: '/admin/:addaction/quote-template/:id',
    title: 'Quote Template',
    component: withLazyLoad(
      () =>
        import('../components/Admin/QuoteTemplate/Components/QuotesTemplate')
    ),
    permissions: permissions.quote?.add,
    identifier: 'quote_template',
  },
  {
    path: '/admin/:editaction/:quoteId/quote-template/:id',
    title: 'Quote Template',
    component: withLazyLoad(
      () =>
        import('../components/Admin/QuoteTemplate/Components/QuotesTemplate')
    ),
    permissions: permissions.quote?.edit,
    identifier: 'quote_template',
  },
  {
    path: '/project/dynamic-action-button',
    title: 'dynamicActionButton',
    component: withLazyLoad(
      () =>
        import(
          '../components/DynamicActionButton/DynamicActionButtonContainer.jsx'
        )
    ),
    permissions: permissions?.templateConfiguration?.view,
    identifier: 'dynamicActionButton',
  },
  {
    path: '/access-denied',
    title: 'Access Denied',
    component: AccessDenied,
    identifier: 'denied_access',
  },
  {
    path: '/web-access-denied',
    title: 'Web Access Denied',
    component: WebAppAccess,
  },
  {
    path: '/crm/:customerId/quotes/:opportunityId?',
    title: 'Quotes',
    component: withLazyLoad(
      () => import('../components/CRM/Quotes/QuoteContainer')
    ),
    permissions: permissions.clients.addClient,
    identifier: 'quotes',
  },
  {
    path: '/crm/:customerId/:opportunityId/quote/:mode/:actionId?',
    title: 'Quote',
    component: withLazyLoad(
      () => import('../components/CRM/Quotes/components/Quote')
    ),
    permissions: permissions.clients.addClient,
    identifier: 'quotes_by_opportunity_id',
  },
  {
    path: '/crm/:customerId/:opportunityId/:quoteTempId/quote/:mode/:actionId?',
    title: 'Quote',
    component: withLazyLoad(
      () => import('../components/CRM/Quotes/components/Quote')
    ),
    permissions: permissions.clients.addClient,
    identifier: 'quotes_by_opportunity_id',
  },

  {
    path: '/project/chargeback/:action',
    title: 'Chargeback',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/Chargeback/ChargebackAction/ChargebackAction.js'
        )
    ),
    identifier: 'chargeback',
  },
  {
    path: '/project/chargeback/:action/project/:projectId/chargeback/:chargebackId',
    title: 'Chargeback',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/Chargeback/ChargebackAction/ChargebackAction.js'
        )
    ),
    identifier: 'chargeback_by_project_id',
  },
  {
    path: '/project/chargeback/:action/chargeback/:chargebackId',
    title: 'Chargeback',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/Chargeback/ChargebackAction/ChargebackAction.js'
        )
    ),
    identifier: 'chargeback_by_id',
  },
  {
    path: '/project/chargeback/:action/project/:projectId',
    title: 'Chargeback',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/Chargeback/ChargebackAction/ChargebackAction.js'
        )
    ),
    identifier: 'charge_back',
  },
  {
    path: '/access-denied',
    title: 'Access Denied',
    component: AccessDenied,
    identifier: 'denied_access',
  },
  {
    path: '/payments-config',
    title: 'Payments Configuration',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Configuration/PaymentsConfiguration.jsx')
    ),
    identifier: 'paymen_config',
  },
  {
    path: '/payments/config/edit',
    title: 'Payments Configuration Edit',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Configuration/components/PaymentsConfigurationEdit'
        )
    ),
    identifier: 'edit_payment_config',
  },
  {
    path: '/onboarding-success',
    title: 'Onboard Success',
    component: OnboardSuccess,
    identifier: 'onboard_success',
  },
  {
    path: '/onboarding-refresh',
    title: 'Onboard Refresh',
    component: OnboardRefresh,
    identifier: 'onboard_refresh',
  },
  {
    path: '/audit-log-reports/:id',
    title: 'Audit Log Reports',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/ProjectAuditLog.js')
    ),
  },
  {
    path: '/opportunity-injection-form-config/:clientId',
    title: 'Opportunity Injection Form Config',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/OpportunityInjection/opportunityInjectionConfig.tsx'
        )
    ),
    identifier: 'opportunity_injection_form',
  },
  {
    path: '/create-audit-log-report/:id/add',
    title: 'Create Audit Log Report',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/ProjectAuditLogCreate.js')
    ),
  },
  {
    path: '/create-audit-log-report/:id/edit/:auditId',
    title: 'Create Audit Log Report',
    component: withLazyLoad(
      () => import('../components/Admin/Configuration/ProjectAuditLogCreate.js')
    ),
  },
  {
    path: '/crm/:customerId/:opportunityId/project/view/:projectId?',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.viewProject,
  },
  {
    path: '/crm/:customerId/:opportunityId/project/edit/:projectId?',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.editProject,
  },
  {
    path: '/crm/:customerId/:opportunityId/invoice/:mode/:actionId?',
    title: 'Invoice',
    component: withLazyLoad(
      () => import('../components/CRM/Invoice/components/Invoice.jsx')
    ),
    permissions: permissions.clients.addClient,
  },
  {
    path: '/crm/invoice/:mode/:actionId?',
    title: 'Invoice',
    component: withLazyLoad(
      () => import('../components/CRM/Invoice/components/Invoice.jsx')
    ),
    permissions: permissions.clients.addClient,
  },
  {
    path: '/:opportunityId/:quoteId/project/:actionId',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.addProject,
    identifier: 'project_details_by_opportunity_id',
  },
  {
    path: `/technician-po/:projectId/:technicianId/:technicianUserId`,
    title: 'Technician-po',
    component: withLazyLoad(
      () => import('../components/ProjectManagement/ProjectItems/TechnicianPO')
    ),
  },
  {
    path: `/technician-po/:projectId/default-po`,
    title: 'Technician-po',
    component: withLazyLoad(
      () => import('../components/ProjectManagement/ProjectItems/TechnicianPO')
    ),
  },
  {
    path: '/measure-square-config',
    title: 'MeasureSquare Configuration',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Configuration/MeasureSquareConfiguration.jsx'
        )
    ),
    identifier: 'measure_square_config',
  },
  {
    path: '/crm/:customerId/projects/:opportunityId?',
    title: 'Projects',
    component: withLazyLoad(
      () => import('../components/CRM/Quotes/QuoteContainer')
    ),
    identifier: 'projects',
  },
  {
    path: '/crm/add/:opportunityId',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.addProject,
  },
  {
    path: '/admin/payroll',
    title: 'Payroll',
    component: withLazyLoad(
      () => import('../components/Admin/Payroll/PayrollContainer.js')
    ),
  },
  {
    path: '/admin/invoice-payments',
    title: 'Invoice Payments',
    component: withLazyLoad(
      () =>
        import('../components/Admin/InvoicePayments/InvoicePaymentsContainer')
    ),
  },
  {
    path: '/admin/checklist',
    title: 'Checklist',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Questionnaire/QuestionnaireComponent.js')
    ),
    permissions: permissions.questionnaire.view,
  },
  {
    path: '/admin/export/reports',
    title: 'Exported Reports',
    component: withLazyLoad(
      () => import('../components/Admin/ExportedReports/ReportContainer')
    ),
  },
  {
    path: '/project-color-code',
    title: 'Add New Color',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/ProjectColorCodeConfig/ProjectColorCode'
        )
    ),
  },
  {
    path: '/admin/dashboard-performance-analysis',
    title: 'Dashboard Performance Analysis',
    component: DashboardPerformanceAnalysisContainer,
  },
  {
    path: '/data-import',
    title: 'Data Import',
    component: withLazyLoad(() => import('../components/ImportData')),
  },
  {
    path: '/admin/configuration/group-source-category',
    title: 'Group Source Category',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/GroupSourceCategory/GroupSourceCatgory'
        )
    ),
  },
  {
    path: '/admin/configuration/group-source-category/add',
    title: 'Group Source Category',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/GroupSourceCategory/AddEditGroupSource'
        )
    ),
  },
  {
    path: '/admin/configuration/group-source-category/edit/:id',
    title: 'Group Source Category',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/GroupSourceCategory/AddEditGroupSource'
        )
    ),
  },
  {
    path: '/admin/configuration/scheduler-rts-report',
    title: 'Scheduler RTS Report Filters',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/SchedularReportConfig/SchedularRTSReportFilter'
        )
    ),
  },
  {
    path: '/change-password',
    title: 'Change Password',
    component: withLazyLoad(
      () => import('../components/Admin/Auth/Login/ChangePassword')
    ),
  },
  {
    path: '/set-pin',
    title: 'Set pin',
    component: withLazyLoad(
      () => import('../components/Admin/Auth/Login/components/Mpin')
    ),
  },

  {
    path: '/logs/login-logs',
    title: 'Login Logs',
    component: withLazyLoad(
      () => import('../components/Admin/Logs/LoginLogs/LoginLogsContainer')
    ),
  },
  {
    path: '/logs/reset-password-logs',
    title: 'Reset Password Logs',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Logs/ResetPasswordLogs/ResetPasswordLogs')
    ),
  },
  {
    path: '/logs/customer-login-logs',
    title: 'Customer Login Logs',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Logs/CustomerLoginLogs/CustomerLoginLogs')
    ),
  },
  {
    path: '/logs/customer-register-logs',
    title: 'Customer Register Logs',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Logs/CustomerRegisterLogs/CustomerRegisterLogs'
        )
    ),
  },
  {
    path: '/logs/customer-reset-password-logs',
    title: 'Customer Reset Password Logs',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Logs/CustomerResetPasswordLogs/CustomerResetPasswordLogs'
        )
    ),
  },
  {
    path: '/admin/company/configuration/related-po/edit/:id',
    title: 'Related POs',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/RelatedPOsConfig/RelatedPOsConfig'
        )
    ),
  },
  {
    path: '/admin/company/configuration/reminder-popup',
    title: 'Reminder Configuration',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/ReminderConfig/ReminderPopupConfig'
        )
    ),
  },
  {
    path: '/cache-sync',
    title: 'Cache Sync',
    component: withLazyLoad(() => import('../components/Admin/sync/RedisSync')),
  },
  {
    path: '/admin/custom-layout',
    title: 'Project Layout',
    component: withLazyLoad(
      () => import('../components/Admin/DynamicLayout/DynamicLayoutContainer')
    ),
  },

  {
    path: '/admin/project-layout/:id/:entityId',
    title: 'Project Layout',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/DynamicLayout/components/AddEditLayoutConfig'
        )
    ),
  },
  {
    path: '/brand-logo',
    title: 'Brand Logo',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/NewConfiguration/AdditionalFeatures/BrandLogo/BrandLogoContainer'
        )
    ),
    identifier: 'brand_logo',
  },
  {
    path: '/project/activities',
    title: 'Activities',
    component: withLazyLoad(
      () => import('../components/activities/ActivitiesContainer')
    ),
    identifier: 'activities',
  },
  {
    path: '/project/:action/:projectId?',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.viewProject,
    identifier: 'view_project_details',
  },
  {
    path: '/project/:action',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.addProject,
    identifier: 'add_project_details',
  },
  {
    path: '/new-project/add',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.addProject,
    identifier: 'add_project_details',
  },
  {
    path: '/new-project/view/:projectId?',
    title: 'Project Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectInfo/AddViewEditProjectContainer'
        )
    ),
    permissions: permissions.project.viewProject,
    identifier: 'view_project_details',
  },
  {
    path: '/admin/user-activity',
    title: 'User Activity',
    component: withLazyLoad(
      () => import('../components/Admin/UserActivity/UserActivity')
    ),
    // permissions: permissions.project.viewProject,
    identifier: 'user_activity',
  },
  {
    path: '/admin/help-page-config',
    title: 'Help Page Config',
    component: withLazyLoad(
      () => import('../components/Admin/HelpPageConfig/HelpPageConfigContainer')
    ),
  },
  {
    path: '/get-started',
    title: 'Get Started',
    component: withLazyLoad(
      () => import('../components/UserGuide/GetStartedContainer')
    ),
    identifier: 'page_updates_userguide',
  },
  {
    path: '/calender-integration-success',
    title: 'Calendar Integration Success',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Auth/Login/components/CalenderConsentSuccess'
        )
    ),
    identifier: 'calender_integration_success',
  },
  {
    path: '/calender-integration-failed',
    title: 'Calendar Integration Failed',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Auth/Login/components/CalenderConsentFailure'
        )
    ),
    identifier: 'calender_integration_failed',
  },
  {
    path: '/email-tracking',
    title: 'Email Tracker Dashboard',
    component: withLazyLoad(
      () => import('../components/Admin/EmailTrackerDashboard/Dashboard')
    ),
    permissions: permissions.emailEventDashboard.view,
  },
  {
    path: '/technician-invoice/:projectId/:invoiceId',
    title: 'Technician Invoice',
    component: withLazyLoad(
      () =>
        import(
          '../components/ProjectManagement/ProjectItems/TechnicianInvoice.js'
        )
    ),
  },
  {
    path: '/masterpart',
    title: 'MasterPart',
    component: withLazyLoad(
      () => import('../components/Admin/MasterParts/MasterPartContainer')
    ),
    // permissions: permissions.stores.menu,
    identifier: 'masterpart',
  },
  {
    path: '/masterpart/add',
    title: 'MasterPart Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MasterParts/components/AddViewEditMasterPart'
        )
    ),
    // permissions: permissions.stores.storesAdd,
    identifier: 'add_masterpart_details',
  },
  {
    path: '/masterpart/view/:masterpartId?',
    title: 'MasterPart Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MasterParts/components/AddViewEditMasterPart'
        )
    ),
    // permissions: permissions.stores.menu,
    identifier: 'view_masterpart_details',
  },
  {
    path: '/masterpart/edit/:masterpartId?',
    title: 'MasterPart Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/MasterParts/components/AddViewEditMasterPart'
        )
    ),
    // permissions: permissions.stores.storesEdit,
    identifier: 'view_masterpart_details',
  },
  {
    path: '/brand',
    title: 'Brand',
    component: withLazyLoad(
      () => import('../components/Admin/Brand/BrandContainer')
    ),
    // permissions: permissions.brand.menu,
    identifier: 'Brand',
  },
  {
    path: '/brand/view/:brandId?',
    title: 'Brand Details',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Brand/components/AddViewEditBrandDetails')
    ),
    // permissions: permissions.brand.menu,
    identifier: 'view_brand_details',
  },
  {
    path: '/brand/edit/:brandId?',
    title: 'Brand Details',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Brand/components/AddViewEditBrandDetails')
    ),
    // permissions: permissions.brand.brandEdit,
    identifier: 'edit_brand_details',
  },
  {
    path: '/brand/add',
    title: 'Brand Details',
    component: withLazyLoad(
      () =>
        import('../components/Admin/Brand/components/AddViewEditBrandDetails')
    ),
    // permissions: permissions.brand.brandAdd,
    identifier: 'add_brand_details',
  },
  {
    path: '/admin/sso-configuration',
    title: 'SSO Configuration',
    component: withLazyLoad(
      () =>
        import('../components/Admin/SsoConfiguration/SsoConfigurationContainer')
    ),
    identifier: 'sso_configuration',
  },
  {
    path: '/admin/sso-configuration/:client_id',
    title: 'SSO Configuration',
    component: withLazyLoad(
      () =>
        import('../components/Admin/SsoConfiguration/SsoConfigurationContainer')
    ),
    identifier: 'sso_configuration',
  },
  {
    path: '/admin/historical-forecast-settings',
    title: 'Historical forecast settings',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/HistoricalForecast/HistoricalForecastContainer'
        )
    ),
    // permissions: permissions.historicalforecast.menu,
    identifier: 'historical_forecast',
  },
  {
    path: '/admin/historical-forecast-settings/add',
    title: 'Historical forecast settings Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/HistoricalForecast/components/AddViewEditHistoricalForecast'
        )
    ),
    // permissions: permissions.historicalforecast.storesAdd,
    identifier: 'add_historical_forecast',
  },
  {
    path: '/admin/historical-forecast-settings/view/:historicalforecastId?',
    title: 'Historical forecast settings Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/HistoricalForecast/components/AddViewEditHistoricalForecast'
        )
    ),
    // permissions: permissions.historicalforecast.menu,
    identifier: 'view_historical_forecast',
  },
  {
    path: '/admin/historical-forecast-settings/edit/:historicalforecastId?',
    title: 'Historical forecast settings Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/HistoricalForecast/components/AddViewEditHistoricalForecast'
        )
    ),
    // permissions: permissions.historicalforecast.storesEdit,
    identifier: 'edit_historical_forecast',
  },
  {
    path: '/architecture',
    title: 'Architecture',
    component: withLazyLoad(
      () => import('../components/Admin/Architecture/ArchitectureContainer')
    ),
    // permissions: permissions.stores.menu,
    identifier: 'architecture',
  },
  {
    path: '/architecture/add',
    title: 'Architecture Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Architecture/components/AddViewEditArchitecture'
        )
    ),
    // permissions: permissions.stores.storesAdd,
    identifier: 'add_architecture_details',
  },
  {
    path: '/architecture/view/:architectureId?',
    title: 'Architecture Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Architecture/components/AddViewEditArchitecture'
        )
    ),
    // permissions: permissions.stores.menu,
    identifier: 'view_architecture_details',
  },
  {
    path: '/architecture/edit/:architectureId?',
    title: 'Architecture Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/Architecture/components/AddViewEditArchitecture'
        )
    ),
    // permissions: permissions.stores.storesEdit,
    identifier: 'view_architecture_details',
  },
  {
    path: '/admin/install-guide-request',
    title: 'Install Guide Request',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/InstallGuideRequest/InstallGuideRequestContainer'
        )
    ),
    // permissions: permissions.userManagement.menu,
    identifier: 'install_guide_request',
  },
  {
    path: '/admin/install-guide-request/view/:installGuideRequestId?',
    title: 'Install Guide Request Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/InstallGuideRequest/components/AddViewEditInstallGuideRequest'
        )
    ),
    // permissions: permissions.brand.menu,
    identifier: 'view_install_guide_request',
  },
  {
    path: '/admin/install-guide-request/edit/:installGuideRequestId?',
    title: 'Install Guide Request Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/InstallGuideRequest/components/AddViewEditInstallGuideRequest'
        )
    ),
    // permissions: permissions.brand.brandEdit,
    identifier: 'edit_install_guide_request',
  },
  {
    path: '/admin/install-guide-request/add',
    title: 'Install Guide Request Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/InstallGuideRequest/components/AddViewEditInstallGuideRequest'
        )
    ),
    // permissions: permissions.brand.brandAdd,
    identifier: 'add_install_guide_request',
  },
  {
    path: '/admin/fire-design-request',
    title: 'Fire Design Request',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/FireDesignRequest/FireDesignRequestContainer'
        )
    ),
    // permissions: permissions.userManagement.menu,
    identifier: 'fire_design_request',
  },
  {
    path: '/admin/fire-design-request/view/:fireDesignRequestId?',
    title: 'Fire Design Request Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/FireDesignRequest/components/AddViewEditFireDesignRequest'
        )
    ),
    // permissions: permissions.brand.menu,
    identifier: 'view_fire_system_design',
  },
  {
    path: '/admin/fire-design-request/edit/:fireDesignRequestId?',
    title: 'Fire Design Request Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/FireDesignRequest/components/AddViewEditFireDesignRequest'
        )
    ),
    // permissions: permissions.brand.brandEdit,
    identifier: 'edit_fire_system_design',
  },
  {
    path: '/admin/fire-design-request/add',
    title: 'Fire Design Request Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/FireDesignRequest/components/AddViewEditFireDesignRequest'
        )
    ),
    // permissions: permissions.brand.brandAdd,
    identifier: 'add_fire_system_design',
  },
  {
    path: '/admin/system-design',
    title: 'System Design',
    component: withLazyLoad(
      () => import('../components/Admin/SystemDesign/SystemDesignContainer.tsx')
    ),
    // permissions: permissions.userManagement.menu,
    identifier: 'system_design',
  },
  {
    path: '/admin/system-design/view/:systemDesignId?',
    title: 'System Design Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/SystemDesign/components/AddViewEditSystemDesign.tsx'
        )
    ),
    // permissions: permissions.brand.menu,
    identifier: 'view_system_design',
  },
  {
    path: '/admin/system-design/edit/:systemDesignId?',
    title: 'System Design Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/SystemDesign/components/AddViewEditSystemDesign.tsx'
        )
    ),
    // permissions: permissions.brand.brandEdit,
    identifier: 'edit_system_design',
  },
  {
    path: '/admin/system-design/add',
    title: 'System Design Details',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/SystemDesign/components/AddViewEditSystemDesign.tsx'
        )
    ),
    // permissions: permissions.brand.brandAdd,
    identifier: 'add_system_design',
  },
  {
    path: '/admin/entity-layout',
    title: 'Entity Layout',
    component: withLazyLoad(
      () => import('../components/Admin/Entity/EntityContainer')
    ),
  },
  {
    path: '/admin/entity/:entityId/layouts/:layoutId',
    title: 'Entity Layout',
    component: withLazyLoad(
      () =>
        import(
          '../components/Admin/EntityLayouts/components/AddEditEntityLayoutConfig'
        )
    ),
  },
  {
    path: '/admin/entity-layout/:entityId/layouts',
    title: 'Entity Layout',
    component: withLazyLoad(
      () => import('../components/Admin/Entity/EntityContainer')
    ),
  },
  {
    path: '/admin/entity',
    title: 'Entity',
    component: withLazyLoad(
      () => import('../components/Admin/EntityPage/EntityContainer')
    ),
    identifier: 'entity',
  },
  {
    path: '/admin/entity/:entityId/:tabId',
    title: 'Entity',
    component: withLazyLoad(
      () => import('../components/Admin/Entity/EntityContainer')
    ),
    identifier: 'entity',
  },
];
